  <div class="card">
          <div class="card-header">
            <h4 class="card-title">{{ 'MENU.DASHBOARD.add_employees' | translate }}</h4>
            <!-- <button class="btn btn-primary" (click)="addCoupon()">
              Add Employees
            </button> -->
          </div>
          <!-- <div class="card-body">
            <p class="card-text">Employees List</p>
          </div> -->
        </div>


<form >
    

    <div class="row">
        <div class="col-sm-4"> 
            <div class="mb-3">
                <label class="form-label">{{ 'MENU.DASHBOARD.name' | translate }}</label>
                <input type="text" class="form-control" placeholder="{{ 'MENU.DASHBOARD.name' | translate }}" [(ngModel)]="formData.name_en" name="name_en" required>
            </div>
        </div><!-- Col -->

        <div class="col-sm-4">
            <div class="mb-3">
                <label class="form-label">{{ 'MENU.DASHBOARD.email' | translate }}</label>
                <input type="email" class="form-control" placeholder="{{ 'MENU.DASHBOARD.email' | translate }}" [(ngModel)]="formData.email" name="email" required>
            </div>
        </div><!-- Col -->
    </div><!-- Row -->

    <div class="row">
        <div class="col-sm-4">
            <div class="mb-3">
                <label class="form-label">{{ 'MENU.DASHBOARD.mobile' | translate }} </label>
                <input type="text" class="form-control" placeholder="{{ 'MENU.DASHBOARD.mobile' | translate }} " [(ngModel)]="formData.mobile" name="mobile" required>
            </div>
        </div><!-- Col -->
         <div class="col-sm-4">
            <div class="mb-3">
                <label class="form-label">{{ 'MENU.DASHBOARD.id_number' | translate }} </label>
                <input type="text" class="form-control" placeholder="{{ 'MENU.DASHBOARD.id_number' | translate }} " [(ngModel)]="formData.id_number" name="id_number" required>
            </div>
        </div><!-- Col -->

        <div class="col-sm-4">
            <div class="mb-3">
              <label for="exampleInputImage" class="form-label">{{ 'MENU.DASHBOARD.image' | translate }}</label>
              <input type="file" class="form-control" id="exampleInputImage" (change)="onFileSelected($event)" 
              accept="image/*" name="image" autocomplete="off">


            </div>
          </div><!-- Col -->
    </div><!-- Row -->

    

    <div class="row">
        <div class="col-sm-4">
            <div class="mb-3 d-flex justify-content-between">
                <button type="submit" class="btn btn-primary">{{ 'MENU.DASHBOARD.add_employee' | translate }}
</button>
                <!-- <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button> -->

                <!-- <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button> -->
            </div>
        </div><!-- Col -->
    </div><!-- Row -->
</form>